var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFulllogowhiteblue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2101.25 559.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#linear-gradient-4);}.cls-6{fill:url(#linear-gradient-5);}.cls-7{fill:url(#linear-gradient-6);}.cls-8{fill:url(#linear-gradient-7);}.cls-9{fill:url(#linear-gradient-8);}.cls-10{fill:url(#linear-gradient-9);}.cls-11{fill:url(#linear-gradient-10);}.cls-12{fill:url(#linear-gradient-11);}.cls-13{fill:url(#linear-gradient-12);}.cls-14{fill:url(#linear-gradient-13);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 991.28,
    y1: -31.41,
    x2: 1038.24,
    y2: 297.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#50ceff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008cad"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 21.89,
    y1: 455.4,
    x2: 2103.29,
    y2: 653.17,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 23.15,
    y1: 442.18,
    x2: 2104.54,
    y2: 639.96,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 24.77,
    y1: 425.1,
    x2: 2106.17,
    y2: 622.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 26.5,
    y1: 406.93,
    x2: 2107.89,
    y2: 604.71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 28.22,
    y1: 388.79,
    x2: 2109.62,
    y2: 586.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 30.04,
    y1: 369.69,
    x2: 2111.43,
    y2: 567.47,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 31.33,
    y1: 356.07,
    x2: 2112.73,
    y2: 553.85,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 33.25,
    y1: 335.89,
    x2: 2114.64,
    y2: 533.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 35.16,
    y1: 315.8,
    x2: 2116.55,
    y2: 513.58,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 36.43,
    y1: 302.42,
    x2: 2117.82,
    y2: 500.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 37.53,
    y1: 290.83,
    x2: 2118.92,
    y2: 488.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 38.98,
    y1: 275.56,
    x2: 2120.38,
    y2: 473.34,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M159.94,315q-68.88,0-114.41-45T0,157.41q0-67,45.43-112.19T158.68,0q60.21,0,99.41,30.74t49.12,70.89L237.06,119q-6.12-20.7-27.25-36.13T159.1,67.4q-38.46,0-62,26T73.53,157q0,37.19,23.77,63.8t61.8,26.63q29.79,0,50.81-14.9t27.15-35.6l70.15,17.75q-9.93,39.72-48.91,70T159.94,315Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M538.14,5.92h72.69V183q0,59.81-35.39,95.93t-99,36.13q-64,0-99.3-36.13T341.86,183V5.92h72.68V181.71q0,30.21,15.74,48.8t46.06,18.6q30.32,0,46.06-18.6t15.74-48.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M848.1,308.9l-64.44-99.52h-52V308.9h-71V5.92H812.18q48,0,77.65,30.95t29.68,71.31a99.14,99.14,0,0,1-16.26,54.93Q887,188.27,857.61,200.3l73.1,108.6ZM731.68,70.15v76.48H806.9q18.58,0,30.74-11.2t12.15-27.25q0-15.63-11.73-26.84a39.38,39.38,0,0,0-28.2-11.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M965.15,308.9V126.58h72.68V308.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M965.15,74.58v-69h72.68v69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1395.12,136.7v35.92q0,62.32-42.47,102.37t-111.56,40q-70.58,0-116.84-45.22T1078,157.51q0-67.08,45.85-112.29T1237.5,0q54.93,0,93.7,26.83t54,67l-66.77,19q-23.88-45.43-80.08-45.43-38.44,0-63.06,26T1150.66,157q0,37.6,25.25,64.44t70.67,26.83q30.64,0,49.55-14.68t23.56-35.39l-79.44.42V136.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1688.38,5.92h68.46v303H1685V131.42l-89.16,121.7-88.74-121.7V308.9h-71.84V5.92h68.25l92.75,134.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2027.07,308.9,2006,251h-128l-21.34,57.89h-74l112-303H1989l112,303ZM1900.72,188.26h82.2l-41-113.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M161.45,371.54v39.63H102.66V556H58.92V411.17H.25V371.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M320,411.17h-96.1v32h82.72v38.21H223.85v35.12h95.84V556H181.14V371.54H320Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M432.65,559.76q-41.94,0-69.67-27.4t-27.72-68.57q0-40.79,27.66-68.32t69-27.53q36.66,0,60.53,18.72t29.91,43.16l-42.71,10.55q-3.74-12.6-16.6-22T432.13,409q-23.42,0-37.75,15.82T380,463.53q0,22.64,14.47,38.85t37.63,16.21q18.15,0,30.94-9.07t16.54-21.68l42.71,10.81q-6,24.18-29.78,42.65T432.65,559.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M661.13,371.54h43.74V556H661.13v-74H588.45v74H544.7V371.54h43.75v70.89h72.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M854.88,371.54h43.74V556h-35.5l-83-105.62V556H736.39V371.54H771.9l83,105.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1090.83,532.36q-27.8,27.39-69.92,27.4T951,532.36Q923.2,505,923.19,463.85T951,395.34q27.79-27.4,69.93-27.4t69.92,27.4q27.78,27.41,27.79,68.51T1090.83,532.36ZM982.18,503.6q14.73,15.76,38.73,15.76t38.72-15.76q14.73-15.75,14.73-39.75T1059.63,424q-14.73-15.82-38.72-15.82T982.18,424q-14.73,15.83-14.73,39.82T982.18,503.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1186.8,516h86.71v40H1143.06V371.54h43.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1449.76,532.36q-27.78,27.39-69.92,27.4t-69.92-27.4q-27.8-27.4-27.79-68.51t27.79-68.51q27.8-27.4,69.92-27.4t69.92,27.4q27.79,27.41,27.79,68.51T1449.76,532.36ZM1341.12,503.6q14.73,15.76,38.72,15.76t38.73-15.76q14.73-15.75,14.73-39.75T1418.57,424q-14.74-15.82-38.73-15.82T1341.12,424q-14.73,15.83-14.73,39.82T1341.12,503.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1688,451.18v21.87q0,37.95-25.86,62.33t-67.93,24.38q-43,0-71.15-27.53t-28.17-68.38q0-40.85,27.92-68.38t69.21-27.53q33.45,0,57.06,16.34T1682,425.06l-40.65,11.58Q1626.78,409,1592.57,409q-23.41,0-38.41,15.82t-15,38.73q0,22.91,15.37,39.24t43,16.34q18.66,0,30.17-8.95t14.35-21.55l-48.38.26V451.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1712.47,556V371.54h44.26V556Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1927.06,411.17H1831v32h82.72v38.21H1831v35.12h95.84V556H1788.24V371.54h138.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M2025.61,559.76q-32.68,0-55.32-16.21t-31.4-39.75l41.69-12.87a48.45,48.45,0,0,0,17.88,22.13q12.35,8.49,29.72,8.49,12.85,0,20.84-5.15t8-12.22q0-11.31-19.81-17.75l-47.47-14.67q-19.29-6-30.81-18.72a42.17,42.17,0,0,1-11.26-30q-.26-22.89,19.24-39t48.95-16.08q29.2,0,51.52,14.09t29.91,34.41L2057,428.28a42.12,42.12,0,0,0-16.46-16,48.4,48.4,0,0,0-24.19-6.17q-11.05,0-17.75,4.31t-6.69,10.87q0,9.53,12.35,13.25l46.44,14.8q24.2,7.59,37.38,19t13.18,32.8q0,25.1-21,41.81T2025.61,559.76Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFulllogowhiteblue);
export default __webpack_public_path__ + "static/media/full logo white blue.c8a9fdb663f369d048df1fed56d3f0b6.svg";
export { ForwardRef as ReactComponent };